// user
export const GET_CURRENT_USER = 'GET_CURRENT_USER';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const LOAD_USERS_SUCCESS = 'LOAD_USERS_SUCCESS';
export const CURRENT_USER_READY = 'CURRENT_USER_READY';
export const GET_DEMO_ADMIN_USER = 'GET_DEMO_ADMIN_USER';
export const RESET_USER = 'RESET_USER';

//user profile
export const GET_USER_PROFILE_SUCCESS = 'GET_USER_PROFILE_SUCCESS';
export const UPDATE_USER_PROFILE_REGION_ID = 'UPDATE_USER_REGION_ID';
export const UPDATE_USER_PROFILE_MUNICIPALITY_ID = 'UPDATE_USER_MUNICIPALITY_ID';
export const UPDATE_USER_PROFILE_ADDRESS_ID  = 'UPDATE_USER_ADDRESS_ID';
export const GET_USER_PROFILE_ADDRESS_DETAILS_SUCCESS = 'GET_USER_ADDRESS_DETAILS_SUCCESS';
export const SEARCH_USER_PROFILE_ADDRESS_SUCCESS = 'SEARCH_USER_ADDRESS_SUCCESS';
export const CLEAR_USER_PROFILE_ADDRESS_SEARCH_RESULT = 'CLEAR_USER_ADDRESS_SEARCH_RESULT';
export const CLEAR_USER_PROFILE_CITY_INFORMATION = 'CLEAR_USER_CITY_INFORMATION';
export const PRELOAD_USER_PROFILE_ADDRESS_SUCCESS = 'PRELOAD_USER_ADDRESS_SUCCESS';
export const UPDATE_USER_PROFILE_SUCCESS = 'UPDATE_USER_PROFILE_SUCCESS';
export const CLEAR_USER_PROFILE_MUNICIPALITY_ID = 'CLEAR_USER_PROFILE_MUNICIPALITY_ID';
export const CLEAR_USER_PROFILE_ADDRESS_ID = 'CLEAR_USER_PROFILE_ADDRESS_ID';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DETACH_COMPANY_SUCCESS = 'DETACH_COMPANY_SUCCESS';
//
export const GET_COURSE_SUCCESS = 'GET_COURSE_SUCCESS';
export const CLONE_COURSE_SUCCESS = 'CLONE_COURSE_SUCCESS';
export const CREATE_COURSE_SUCCESS = 'CREATE_COURSE_SUCCESS';
export const UPDATE_COURSE_SUCCESS = 'UPDATE_COURSE_SUCCESS';
export const DELETE_COURSE_SUCCESS = 'DELETE_COURSE_SUCCESS';
export const LOAD_COURSES_SUCCESS = 'LOAD_COURSES_SUCCESS';
export const CLEAR_COURSES_LIST = 'CLEAR_COURSES_LIST';
export const RESET_COURSE = 'RESET_COURSE';

export const LOAD_CONTACT_PERSONS_SUCCESS = 'LOAD_CONTACT_PERSONS_SUCCESS';
export const LOAD_CURRENCIES_SUCCESS = 'LOAD_CURRENCIES_SUCCESS';
export const LOAD_PRICE_TYPE_SUCCESS = 'LOAD_PRICE_TYPE_SUCCESS';
export const LOAD_COURSE_CATEGORIES_SUCCESS = 'LOAD_COURSE_CATEGORIES_SUCCESS';
export const LOAD_COURSE_TYPES_SUCCESS = 'LOAD_COURSE_TYPES_SUCCESS';
export const CREATE_CONTACT_PERSON_SUCCESS = 'CREATE_CONTACT_PERSON_SUCCESS';
export const CREATE_CONTACT_PERSON_ERROR = 'CREATE_CONTACT_PERSON_ERROR';
export const UPDATE_CONTACT_PERSON_SUCCESS = 'UPDATE_CONTACT_PERSON_SUCCESS';
export const CLONE_CONTACT_PERSON_SUCCESS = 'CLONE_CONTACT_PERSON_SUCCESS';
export const DELETE_CONTACT_PERSON_SUCCESS = 'DELETE_CONTACT_PERSON_SUCCESS';
export const GET_CONTACT_PERSON_SUCCESS = 'GET_CONTACT_PERSON_SUCCESS';
export const SHOW_CONTACT_PERSON_MODAL = 'SHOW_CONTACT_PERSON_MODAL';
export const HIDE_CONTACT_PERSON_MODAL = 'HIDE_CONTACT_PERSON_MODAl';
export const SHOW_CONTACT_PERSON_DELETE_MODAL = 'SHOW_CONTACT_PERSON_DELETE_MODAL';
export const HIDE_CONTACT_PERSON_DELETE_MODAL = 'HIDE_CONTACT_PERSON_DELETE_MODAl';
export const RESET_CONTACT_PERSON = 'RESET_CONTACT_PERSON';

// catalogs
export const FETCH_CATALOGS = 'FETCH_CATALOGS';
export const GET_CATALOG = 'GET_CATALOG';
export const CREATE_CATALOG = 'CREATE_CATALOG';
export const UPDATE_CATALOG = 'UPDATE_CATALOG';
export const CLONE_CATALOG = 'CLONE_CATALOG';
export const RESET_ACTIVE_CATALOG = 'RESET_ACTIVE_CATALOG';
export const DELETE_CATALOG = 'DELETE_CATALOG';

// job actions
export const GET_DEFAULT_JOB_STATE = 'GET_DEFAULT_JOB_STATE';
export const LOAD_JOBS_SUCCESS = 'LOAD_JOBS_SUCCESS';
export const LOAD_JOB_SUCCESS = 'LOAD_JOB_SUCCESS';
export const LOAD_JOB_REGIONS_SUCCESS = 'LOAD_JOB_REGIONS_SUCCESS';
export const LOAD_JOB_WORKING_TIMES_SUCCESS = 'LOAD_JOB_WORKING_TIMES_SUCCESS';
export const LOAD_JOB_CATEGORIES_SUCCESS = 'LOAD_JOB_CATEGORIES_SUCCESS';
export const CREATE_JOB_SUCCESS = 'CREATE_JOB_SUCCESS';
export const UPDATE_JOB_SUCCESS = 'UPDATE_JOB_SUCCESS';
export const DELETE_JOB_SUCCESS = 'DELETE_JOB_SUCCESS';
export const CLONE_JOB_SUCCESS = 'CLONE_JOB_SUCCESS';
export const SHOW_JOB_DELETE_MODAL = 'SHOW_JOB_DELETE_MODAL';
export const HIDE_JOB_DELETE_MODAL = 'HIDE_JOB_DELETE_MODAL';

export const GET_CURRENT_USER_SUCCESS = 'GET_CURRENT_USER_SUCCESS';

// company actions
export const GET_COMPANY_SUCCESS    = 'GET_COMPANY_SUCCESS';
export const CREATE_COMPANY_SUCCESS = 'CREATE_COMPANY_SUCCESS';
export const UPDATE_COMPANY_SUCCESS = 'UPDATE_COMPANY_SUCCESS';
export const RESET_COMPANY_PROFILE_STATE = 'RESET_COMPANY_PROFILE_STATE';
export const DELETE_COMPANY_SUCCESS = 'DELETE_COMPANY';
export const SEARCH_COMPANY_ADDRESS = 'SEARCH_COMPANY_ADDRESS';
export const LOAD_COMPANY_CATEGORIES_SUCCESS = 'LOAD_COMPANY_CATEGORIES_SUCCESS';
export const LOAD_COMPANY_PORTALS_SUCCESS = 'LOAD_COMPANY_PORTALS_SUCCESS';
export const LOAD_COMPANIES_SUCCESS = 'LOAD_COMPANIES_SUCCESS';
export const SHOW_COMPANY_CATEGORY_RESTRICTION_MODAL = 'SHOW_COMPANY_CATEGORY_RESTRICTION_MODAL';
export const HIDE_COMPANY_CATEGORY_RESTRICTION_MODAL = 'HIDE_COMPANY_CATEGORY_RESTRICTION_MODAL';
export const LOAD_COMPANY_KEYWORDS_PACKS_SUCCESS = 'LOAD_COMPANY_KEYWORDS_PACK_SUCCESS';

// locations
export const LOAD_COUNTRIES_SUCCESS = 'LOAD_COUNTRIES_SUCCESS';
export const LOAD_MUNICIPALITIES_SUCCESS = 'LOAD_MUNICIPALITIES_SUCCESS';
export const LOAD_REGIONS_SUCCESS = 'LOAD_REGIONS_SUCCESS';
export const UPDATE_SELECTED_REGION_ID = 'UPDATE_SELECTED_REGION_ID';
export const UPDATE_SELECTED_MUNICIPALITY_ID = 'UPDATE_SELECTED_MUNICIPALITY_ID';
export const UPDATE_SELECTED_ADDRESS_ID = 'UPDATE_SELECTED_ADDRESS_ID';
export const CLEAR_ADDRESS_SEARCH_RESULT = 'CLEAR_ADDRESS_SEARCH_RESULT';
export const GET_ADDRESS_DETAILS_SUCCESS = 'GET_ADDRESS_DETAILS_SUCCESS';
export const PRELOAD_ADDRESSES_SUCCESS = ' PRELOAD_ADDRESSES_SUCCESS';
export const CHANGE_PRELOAD_ADDRESS_STATUS = 'CHANGE_PRELOAD_ADDRESS_STATUS';
export const CLEAR_CITY_INFORMATION = 'CLEAR_COMPANY_INFORMATION';
export const LOAD_COMPANY_ARTICLES_CATEGORIES_SUCCESS = 'LOAD_COMPANY_ARTICLES_CATEGORIES_SUCCESS';
export const LOAD_COMPANY_REGIONS_SUCCESS = 'LOAD_COMPANY_REGIONS_SUCCESS';
export const LOAD_COMPANY_MUNICIPALITIES_SUCCESS = 'LOAD_COMPANY_MUNICIPALITIES_SUCCESS';
export const CLEAR_COMPANY_MUNICIPALITIES = 'CLEAR_COMPANY_MUNICIPALITIES';
export const UPDATE_COMPANY_PREVIEW_LOCATION = 'UPDATE_COMPANY_PREVIEW_LOCATION';

export const LOAD_ARTICLES_SUCCESS = 'LOAD_ARTICLES_SUCCESS';
export const CREATE_ARTICLE_SUCCESS = 'CREATE_ARTICLE_SUCCESS';
export const GET_ARTICLE_SUCCESS = 'GET_ARTICLE_SUCCESS';
export const CLONE_ARTICLE_SUCCESS = 'CLONE_ARTICLE_SUCCESS';
export const LOAD_TEMPLATES_SUCCESS = 'LOAD_TEMPLATES_SUCCESS';
export const LOAD_ARTICLE_CATEGORIES_SUCCESS = 'LOAD_ARTICLE_CATEGORIES_SUCCESS';
export const CREATE_ARTICLE_CATEGORY_SUCCESS = 'CREATE_ARTICLE_CATEGORY_SUCCESS';
export const UPDATE_ARTICLE_CATEGORY_SUCCESS = 'UPDATE_ARTICLE_CATEGORY_SUCCESS';
export const GET_ARTICLE_CATEGORY_SUCCESS = 'GET_ARTICLE_CATEGORY_SUCCESS';
export const DELETE_ARTICLE_CATEGORY_SUCCESS = 'DELETE_ARTICLE_CATEGORY_SUCCESS';
export const REACTIVATE_ARTICLE_CATEGORY_SUCCESS = 'REACTIVATE_ARTICLE_CATEGORY_SUCCESS';
export const RESET_ARTICLE_CATEGORY = 'RESET_ARTICLE_CATEGORY';
export const RESET_ARTICLE = 'RESET_ARTICLE';

export const GET_PRODUCT_SUCCESS = 'GET_PRODUCT_SUCCESS';
export const LOAD_PRODUCTS_SUCCESS = 'LOAD_PRODUCTS_SUCCESS';
export const CREATE_PRODUCT_SUCCESS = 'CREATE_PRODUCT_SUCCESS';
export const LOAD_PRODUCT_TYPES_SUCCESS = 'LOAD_PRODUCT_TYPES_SUCCESS';
export const DELETE_PRODUCT_SUCCESS = 'DELETE_PRODUCT_SUCCESS';
export const CLONE_PRODUCT_SUCCESS = 'CLONE_PRODUCT_SUCCESS';
export const LOAD_PRODUCT_CATEGORIES_SUCCESS = 'LOAD_PRODUCT_CATEGORIES_SUCCESS';

// certificates
export const INIT_SELECTED_CERTIFICATES = 'INIT_SELECTED_CERTIFICATES';
export const LOAD_CERTIFICATES_SUCCESS = 'LOAD_CERTIFICATES_SUCCESS';
export const SELECT_THE_CERTIFICATE = 'SELECT_THE_CERTIFICATE';
export const DESELECT_THE_CERTIFICATE = 'DESELECT_THE_CERTIFICATE';
export const UPDATE_THE_CERTIFICATES = 'UPDATE_THE_CERTIFICATES';
export const FILTER_CERTIFICATES = 'FILTER_CERTIFICATES';

// spinner actions
export const SHOW_SPINNER_SUCCESS = 'SHOW_SPINNER_SUCCESS';
export const HIDE_SPINNER_SUCCESS = 'HIDE_SPINNER_SUCCESS';
export const DELETE_ARTICLE_SUCCESS = 'DELETE_ARTICLE_SUCCESS';
export const ADD_SPINNER_BUTTON_SUCCESS = 'ADD_SPINNER_BUTTON_SUCCESS';
export const REMOVE_SPINNER_BUTTON_SUCCESS = 'REMOVE_SPINNER_BUTTON_SUCCESS';

// Multi-step select
export const SELECT_MULTISTEP_ITEM = 'SELECT_MULTISTEP_ITEM';
export const DESELECT_MULTISTEP_ITEM = 'DESELECT_MULTISTEP_ITEM';
export const CHANGE_MULTISTEP_SELECT_QUERY = 'CHANGE_MULTISTEP_SELECT_QUERY';
export const FOCUS_MULTISTEP_SELECT_INPUT = 'FOCUS_MULTISTEP_SELECT_INPUT';
export const ADD_MULTISTEP_ITEM = 'ADD_MULTISTEP_ITEM';
export const DELETE_MULTISTEP_ITEM = 'DELETE_MULTISTEP_ITEM';

// Supplier competencies
export const GET_SUPPLIER_COMPETENCIES = 'GET_SUPPLIER_COMPETENCIES';
export const GET_SUPPLIER_COMPETENCIES_SUCCESS = 'GET_SUPPLIER_COMPETENCIES_SUCCESS';
export const GET_SELECTED_COMPETENCIES_SUCCESS = 'GET_SELECTED_COMPETENCIES_SUCCESS';
export const GET_SUPPLIER_COMPETENCIES_ERROR = 'GET_SUPPLIER_COMPETENCIES_ERROR';
export const CACHE_SUPPLIER_COMPETENCIES = 'CACHE_SUPPLIER_COMPETENCIES';
export const ALIGN_SUPPLIER_COMPETENCIES = 'ALIGN_SUPPLIER_COMPETENCIES';

// Services actions
export const LOAD_SERVICES_SUCCESS = 'LOAD_SERVICES_SUCCESS';
export const GET_SERVICE_SUCCESS   = 'GET_SERVICE_SUCCESS';
export const DELETE_SERVICE_SUCCESS = 'DELETE_SERVICE_SUCCESS';
export const LOAD_SERVICE_CATEGORIES_SUCCESS = 'LOAD_SERVICE_CATEGORIES_SUCCESS';
export const CREATE_SERVICE_SUCCESS = 'CREATE_SERVICE_SUCCESS';
export const UPDATE_SERVICE_SUCCESS = 'UPDATE_SERVICE_SUCCESS';
export const CLONE_SERVICE_SUCCESS = 'CLONE_SERVICE_SUCCESS';
export const RESET_SERVICE = 'RESET_SERVICE';

// Machines actions
export const GET_MACHINE_SUCCESS = 'GET_MACHINE_SUCCESS';
export const CREATE_MACHINE_SUCCESS = 'CREATE_MACHINE_SUCCESS';
export const UPDATE_MACHINE_SUCCESS = 'UPDATE_MACHINE_SUCCESS';
export const CLONE_MACHINE_SUCCESS = 'CLONE_MACHINE_SUCCESS';
export const DELETE_MACHINE_SUCCESS = 'DELETE_MACHINE_SUCCESS';
export const LOAD_MACHINES_SUCCESS = 'LOAD_MACHINES_SUCCESS';
export const LOAD_MACHINE_CATEGORIES_SUCCESS = 'LOAD_MACHINE_CATEGORIES_SUCCESS';
export const RESET_MACHINE = 'RESET_MACHINE';

// Messages / errors
export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';

//submit button actions
export const SHOW_SUBMIT_BUTTON_SPINNER = 'SHOW_SUBMIT_BUTTON_SPINNER';
export const HIDE_SUBMIT_BUTTON_SPINNER = 'HIDE_SUBMIT_BUTTON_SPINNER';

export const TRIGHER_PREVIEW_MODAL = 'TRIGHER_PREVIEW_MODAL';
export const SHOW_MODAL = 'SHOW_MODAL';
export const SHOW_SWEET_ALERT_MODAL = 'SHOW_SWEET_ALERT_MODAL';
export const HIDE_SWEET_ALERT_MODAL = 'HIDE_SWEET_ALERT_MODAL';
export const SHOW_TEMPLATE_MODAL = 'SHOW_TEMPLATE_MODAL';
export const HIDE_TEMPLATE_MODAL = 'HIDE_TEMPLATE_MODAL';
export const ENABLE_TEMPLATE_MODAL = 'CAN_SHOW_TEMPLATE_MODAL';
export const DISABLE_TEMPLATE_MODAL = 'DISABLE_TEMPLATE_MODAL';
export const SHOW_RESET_FORM_MODAL = 'SHOW_RESET_FORM_MODAL';

// settings
export const GET_SETTINGS_SUCCESS = 'GET_SETTINGS_SUCCESS';
export const GET_SETTING_SUCCESS = 'GET_SETTING_SUCCESS';
export const UPDATE_SETTINGS_SUCCESS = 'UPDATE_SETTINGS_SUCCESS';

// analytics
export const LOAD_ANALYTICS_SUCCESS = 'LOAD_ANALYTICS_SUCCESS';
export const LOAD_ALL_ANALYTICS_SUCCESS = 'LOAD_ALL_ANALYTICS_SUCCESS';
export const LOAD_METRICS_SUCCESS = 'LOAD_METRICS_SUCCESS';
export const LOAD_ANALYTICS_DATE_RANGE_SUCCESS = 'LOAD_ANALYTICS_DATE_RANGE_SUCCESS';
export const LOAD_TOTAL_SUCCESS = 'LOAD_TOTAL_SUCCESS';
export const RESET_METRICS_TABLE = 'RESET_METRICS_TABLE';

// portal-contact
export const GET_PORTAL_CONTACT_SUCCESS = 'GET_PORTAL_CONTACT_SUCCESS';
export const UPDATE_PORTAL_CONTACT_SUCCESS = 'UPDATE_PORTAL_CONTACT_SUCCESS';
export const DELETE_PORTAL_CONTACT_SUCCESS = 'DELETE_PORTAL_CONTACT_SUCCESS';
export const LOAD_PORTAL_CONTACTS_SUCCESS = 'LOAD_PORTAL_CONTACTS_SUCCESS ';
export const CREATE_PORTAL_CONTACT_PERSON_SUCCESS = 'CREATE_PORTAL_CONTACT_PERSON_SUCCESS';

// portal-contact-specialities
export const LOAD_DEPARTMENTS_SUCCESS = 'LOAD_DEPARTMENTS_SUCCESS';
export const GET_DEPARTMENT_SUCCESS = 'GET_DEPARTMENT_SUCCESS';
export const CREATE_DEPARTMENT_SUCESSS = 'CREATE_DEPARTMENT_SUCESSS';
export const UPDATE_DEPARTMENT_SUCCESS = 'UPDATE_DEPARTMENT_SUCCESS';
export const DELETE_DEPARTMENT_SUCCESS = 'DELETE_DEPARTMENT_SUCCESS';
export const LOAD_PORTALS_SUCCESS = 'LOAD_PORTALS_SUCCESS';
export const LOAD_COMPANY_PORTAL_CONTACT_PERSONS_SUCCESS = 'LOAD_COMPANY_PORTAL_CONTACT_PERSONS_SUCCESS';
export const RESET_PORTAL_CONTACT = 'RESET_PORTAL_CONTACT';

// TIPS
export const LOAD_TIPS_SUCCESS  = 'LOAD_TIPS_SUCCESS';
export const CREATE_TIP_SUCCESS = 'CREATE_TIP_SUCCESS';
export const GET_TIP_SUCCESS    = 'GET_TIP_SUCCESS';
export const UPDATE_TIP_SUCCESS = 'UPDATE_TIP_SUCCESS';
export const DELETE_TIP_SUCCESS = 'DELETE_TIP_SUCCESS';
export const CLONE_TIP_SUCCESS  = 'CLONE_TIP_SUCCESS';
export const RESET_TIP = 'RESET_TIP';

// list sorting
export const RESET_SORTABLE_LIST_SUCCESS  = 'RESET_SORTABLE_LIST_SUCCESS';
export const UPDATE_SORTABLE_LIST_SUCCESS  = 'UPDATE_SORTABLE_LIST_SUCCESS';

export const LOAD_ALL_CHANGELOG_SUCCESS  = 'LOAD_ALL_CHANGELOG_SUCCESS';

export const SHOW_TOKEN_VALIDATION_FAILED_MODAL = 'SHOW_TOKEN_VALIDATION_FAILED_MODAL';

// VIMEO
export const ADD_VIMEO_ID       = 'ADD_VIMEO_ID';
export const UPDATE_VIMEO_VIDEO = 'UPDATE_VIMEO_VIDEO';
export const DELETE_VIMEO_VIDEO = 'DELETE_VIMEO_VIDEO';
export const GET_VIMEO_SUCCESS  = 'GET_VIMEO_SUCCESS';

export const TRIGGER_MAINTENANCE_MODE = ''

// Categories
export const LOAD_CATEGORIES_SUCCESS = 'LOAD_CATEGORIES_SUCCESS';
export const LOAD_CATEGORIES_FAIL = 'LOAD_CATEGORIES_FAIL';
export const LOAD_CATEGORIES_PENDING = 'LOAD_CATEGORIES_PENDING';

export const ADD_CATEGORY_SUCCESS = 'ADD_CATEGORY_SUCCESS';
export const ADD_CATEGORY_FAIL = 'ADD_CATEGORY_FAIL';
export const ADD_CATEGORY_PENDING = 'ADD_CATEGORY_PENDING';

export const UPDATE_CATEGORY_SUCCESS = 'UPDATE_CATEGORY_SUCCESS';
export const UPDATE_CATEGORY_FAIL = 'UPDATE_CATEGORY_FAIL';
export const UPDATE_CATEGORY_PENDING = 'UPDATE_CATEGORY_PENDING';

export const DELETE_CATEGORY_SUCCESS = 'DELETE_CATEGORY_SUCCESS';
export const DELETE_CATEGORY_FAIL = 'DELETE_CATEGORY_FAIL';
export const DELETE_CATEGORY_PENDING = 'DELETE_CATEGORY_PENDING';

// Members interests
export const LOAD_PORTALS_CATEGORIES_SUCCESS = 'LOAD_PORTALS_CATEGORIES_SUCCESS';
export const LOAD_INTERESTS_SUCCESS          = 'LOAD_INTERESTS_SUCCESS';
export const UPDATE_INTERESTS_SUCCESS        = 'UPDATE_INTERESTS_SUCCESS';

// Supplier competencies administration
export const LOAD_COMPETENCIES_SUCCESS = 'LOAD_COMPETENCIES_SUCCESS';
export const LOAD_COMPETENCIES_FAIL = 'LOAD_COMPETENCIES_FAIL';

export const ADD_COMPETENCY_SUCCESS = 'ADD_COMPETENCY_SUCCESS';
export const ADD_COMPETENCY_FAIL = 'ADD_COMPETENCY_FAIL';

export const UPDATE_COMPETENCY_SUCCESS = 'UPDATE_COMPETENCY_SUCCESS';
export const UPDATE_COMPETENCY_FAIL = 'UPDATE_COMPETENCY_FAIL';

export const DELETE_COMPETENCY_SUCCESS = 'DELETE_COMPETENCY_SUCCESS';
export const DELETE_COMPETENCY_FAIL = 'DELETE_COMPETENCY_FAIL';
// company tasks
export const LOAD_COMPANY_TASKS_SUCCESS = 'LOAD_COMPANY_TASKS_SUCCESS';
// company regions
export const LOAD_COMPANY_COVER_REGIONS_SUCCESS = 'LOAD_COMPANY_COVER_REGIONS_SUCCESS';

// galleries
export const GET_GALLERY_SUCCESS = 'GET_GALLERY_SUCCESS';
export const CREATE_GALLERY_SUCCESS = 'CREATE_GALLERY_SUCCESS';
export const UPDATE_GALLERY_SUCCESS = 'UPDATE_GALLERY_SUCCESS';
export const DELETE_GALLERY_SUCCESS = 'DELETE_GALLERY_SUCCESS';
export const LOAD_GALLERIES_SUCCESS = 'LOAD_GALLERIES_SUCCESS';
export const RESET_GALLERY = 'RESET_GALLERY';

export const GET_GALLERY_IMAGE_SUCCESS = 'GET_GALLERY_IMAGE_SUCCESS';
export const GET_GALLERY_IMAGES_SUCCESS = 'GET_GALLERY_IMAGES_SUCCESS';
export const CREATE_GALLERY_IMAGE_SUCCESS = 'CREATE_GALLERY_IMAGE_SUCCESS';
export const UPDATE_GALLERY_IMAGE_SUCCESS = 'UPDATE_GALLERY_IMAGE_SUCCESS';
export const DELETE_GALLERY_IMAGE_SUCCESS = 'DELETE_GALLERY_IMAGE_SUCCESS';
export const RESET_GALLERY_IMAGE = 'RESET_GALLERY_IMAGE';
export const SWAP_GALLERY_IMAGES = 'SWAP_GALLERY_IMAGES';
//Machine rental
export const LOAD_MACHINE_RENTS_SUCCESS = 'LOAD_MACHINE_RENTS_SUCCESS';
export const GET_MACHINE_RENT_SUCCESS = 'GET_MACHINE_RENTAL_SUCCESS';
export const CREATE_MACHINE_RENT_SUCCESS = 'CREATE_MACHINE_RENT_SUCCESS';
export const UPDATE_MACHINE_RENT_SUCCESS = 'UPDATE_MACHINE_RENT_SUCCESS';
export const DELETE_MACHINE_RENT_SUCCESS = 'DELETE_MACHINE_RENT_SUCCESS';
export const RESET_MACHINE_RENT_SUCCESS = 'RESET_MACHINE_RENT_SUCCESS';
export const CLEAR_MACHINE_RENT_IMAGE_SUCCESS = 'CLEAR_MACHINE_RENT_IMAGE_SUCCESS';

// rent machine categories
export const LOAD_RENT_MACHINE_CATEGORIES_SUCCESS = 'LOAD_RENT_MACHINE_CATEGORIES_SUCCESS';
export const CREATE_RENT_MACHINE_CATEGORY_SUCCESS = 'CREATE_RENT_MACHINE_CATEGORY_SUCCESS';
export const GET_RENT_MACHINE_CATEGORY_SUCCESS    = 'GET_RENT_MACHINE_CATEGORY_SUCCESS';
export const UPDATE_RENT_MACHINE_CATEGORY_SUCCESS = 'UPDATE_RENT_MACHINE_CATEGORY_SUCCESS';
export const DELETE_DELETE_RENT_MACHINE_CATEGORY_SUCCESS = 'DELETE_DELETE_RENT_MACHINE_CATEGORY_SUCCESS';
export const RESET_RENT_MACHINE_CATEGORY = 'RESET_RENT_MACHINE_CATEGORY';
// park machine categories
export const LOAD_PARK_MACHINE_CATEGORIES_SUCCESS = 'LOAD_PARK_MACHINE_CATEGORIES_SUCCESS';
export const CREATE_PARK_MACHINE_CATEGORY_SUCCESS = 'CREATE_PARK_MACHINE_CATEGORY_SUCCESS';
export const GET_PARK_MACHINE_CATEGORY_SUCCESS    = 'GET_PARK_MACHINE_CATEGORY_SUCCESS';
export const UPDATE_PARK_MACHINE_CATEGORY_SUCCESS = 'UPDATE_PARK_MACHINE_CATEGORY_SUCCESS';
export const DELETE_DELETE_PARK_MACHINE_CATEGORY_SUCCESS = 'DELETE_DELETE_PARK_MACHINE_CATEGORY_SUCCESS';
export const RESET_PARK_MACHINE_CATEGORY = 'RESET_PARK_MACHINE_CATEGORY';

export const LOAD_PARK_MACHINES_SUCCESS = 'LOAD_PARK_MACHINES_SUCCESS';
export const CREATE_PARK_MACHINE_SUCCESS = 'CREATE_PARK_MACHINE_SUCCESS';
export const GET_PARK_MACHINE_SUCCESS    = 'GET_PARK_MACHINE_SUCCESS';
export const UPDATE_PARK_MACHINE_SUCCESS = 'UPDATE_PARK_MACHINE_SUCCESS';
export const DELETE_PARK_MACHINE_SUCCESS = 'DELETE_PARK_MACHINE_SUCCESS';
export const RESET_PARK_MACHINE = 'RESET_PARK_MACHINE';

// keywords pack
export const LOAD_KEYWORDS_PACKS_SUCCESS  = 'LOAD_KEYWORDS_PACKS_SUCCESS';
export const CREATE_KEYWORDS_PACK_SUCCESS = 'CREATE_KEYWORDS_PACK_SUCCESS';
export const GET_KEYWORDS_PACK_SUCCESS    = 'GET_KEYWORDS_PACK_SUCCESS';
export const UPDATE_KEYWORDS_PACK_SUCCESS = 'UPDATE_KEYWORDS_PACK_SUCCESS';
export const DELETE_KEYWORDS_PACK_SUCCESS = 'DELETE_KEYWORDS_PACK_SUCCESS';
export const RESET_KEYWORDS_PACK = 'RESET_KEYWORDS_PACK';



// WEBPACK FOOTER //
// ./web/src/actions/actionTypes.js